<div class="card" [formGroup]="form">
  <div class="action-panel">
    <div class="d-flex gap-2">
      <a
        type="button"
        class="btn btn-secondary"
        [class.disabled]=" isLoading()"
        [routerLink]="isLoading() ? null : '/documents'"
      >
        Cancel
      </a>

      <app-divider [vertical]="true"/>

      @if (isReadyToSentStatus) {
        <button
          type="button"
          class="btn btn-primary d-flex align-items-center gap-2"
          [class.btn-loading]=" isLoading()"
          [disabled]=" isLoading() || isDataInvalid || form.invalid"
          (click)="bulkSendForSign()"
        >
          <i class="icon ic-send-20"></i>
          <span>Bulk send</span>
        </button>
      }
    </div>
  </div>

  <div class="card-body">
    @if (!isLoading() && rows.length) {
      <app-list-grid-client-side
        class="bulk-sign"
        [rowData]="rows"
        [colDefs]="colDefs"
        [rowSelection]="rowSelection"
        [suppressRowClickSelection]="true"
        [suppressCellFocus]="true"
        [pagination]="false"
        (gridReady)="onGridReady($event)"
      />
    } @else {
      <app-loader/>
    }
  </div>

  @if (isReadyToSentStatus) {
    <div class="footer-container">
      <div class="message-container">
        <app-textarea
          formControlName="message"
          label="Message for recipients (optional)"
          [rows]="4"
          [customErrors]="recipientsMessageCustomErrors"
        />

        <app-checkbox
          formControlName="confirm"
          [label]="confirmText"
        />
      </div>
    </div>
  }
</div>
